/**
 * Configuration for Tiny Slider
 *
 * mobileSlider allows sliding elements on mobile, while ignoring larger viewports.
 *
 */
import {tns} from 'tiny-slider/src/tiny-slider';

const initSlider = selector => {
    if (document.querySelector(selector) !== null) {
        // eslint-disable-next-line no-unused-vars
        const slider = tns({
            container: selector,
            preventScrollOnTouch: 'auto',
            controlsText: [
                '<span class="u-hidden-visually">prev</span><i class="fa-solid fa-chevron-left"></i>',
                '<span class="u-hidden-visually">next</span><i class="fa-solid fa-chevron-right"></i>'
            ],
            speed: 800,
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayButtonOutput: false,
            mouseDrag: true
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initSlider('.js_slider');
});
